module.exports = __webpack_public_path__ + "static/img/hua3.bf5b752.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hua3.png
// module id = LTmA
// module chunks = 1